import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL_OLD,
  FETCH_GAME_KEY,
  FETCH_GAME_SORT,
  FETCH_GAME_TAG,
  EDIT_GAME_SORT,
  EDIT_GAME_TAG,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';
import { IKeySort, ISort, IEditSortBody } from '@/interface/GamesManagement';

@Module({ name: 'games-management' })
export default class GamesManagement extends VuexModule {
  @Action
  FetchGameKey(key: IKeySort) {
    return Vue.axios({
      url: BASE_URL_OLD + FETCH_GAME_KEY,
      method: M_POST,
      data: key,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchGameSort(sort: ISort) {
    return Vue.axios({
      url: BASE_URL_OLD + FETCH_GAME_SORT,
      method: M_POST,
      data: sort,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchGameTags(tags: ISort) {
    return Vue.axios({
      url: BASE_URL_OLD + FETCH_GAME_TAG,
      method: M_POST,
      data: tags,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  EditGameSort(gameData: IEditSortBody) {
    return Vue.axios({
      url: BASE_URL_OLD + EDIT_GAME_SORT,
      method: M_POST,
      data: gameData,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  EditGameTags(gameData: IEditSortBody) {
    return Vue.axios({
      url: BASE_URL_OLD + EDIT_GAME_TAG,
      method: M_POST,
      data: gameData,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }
}
